import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const DirectIndirectTaxAdvisory = () => {
  const serviceData = {
    title: "Direct & Indirect Tax Advisory",
    heading: "Direct & Indirect Tax Advisory",
    image: subTopicImages["Direct & Indirect Tax Advisory"],
    intro: "Strategic, legally compliant and business-aligned tax advisory",
    description: [
      "Corporate taxation impacts almost every business decision — including pricing, structuring, contracts, funding, profit repatriation, cost allocation and inter-company arrangements. Misinterpretation of tax provisions or improper documentation can lead to significant financial exposure.",
      "Our Direct & Indirect Tax Advisory practice helps organisations understand the correct tax position, evaluate the impact of tax laws on business operations, identify allowable deductions and exemptions, avoid tax disputes and penal exposure, and achieve tax-efficient outcomes within the law.",
      "We advise clients across sectors including manufacturing, trading, services, technology, consumer goods, e-commerce and logistics.",
    ],
    services: [
      {
        title: "Corporate Tax Advisory & Compliance",
        text: "We support organisations through:",
        list: [
          "computation of taxable income",
          "evaluation of deductibility of expenses",
          "review of financial statements for tax exposure",
          "advisory on cross-charges and reimbursements",
          "preparation and review of tax returns",
        ],
        extraInfo:
          "Ensuring accurate tax positions and proactive risk identification.",
      },
      {
        title: "Withholding Tax (TDS/TCS) Advisory",
        text: "Our services include:",
        list: [
          "applicability analysis on domestic & foreign payments",
          "rate determination",
          "treaty benefit evaluation",
          "certificate & reporting assistance",
        ],
        extraInfo:
          "Helping businesses remain compliant while optimising withholding tax outcomes.",
      },
      {
        title: "Indirect Tax Impact Assessment",
        text: "We assess:",
        list: [
          "GST implications on transactions",
          "customs duty evaluation",
          "indirect tax accounting review",
        ],
        extraInfo:
          "Providing clarity on indirect tax exposure across supply chains.",
      },
      {
        title: "Transaction-Based Advisory",
        text: "We advise on:",
        list: [
          "restructurings",
          "mergers",
          "acquisitions",
          "asset transfers",
          "capital transactions",
        ],
        extraInfo:
          "With detailed tax impact analysis to support informed decision-making.",
      },
    ],
    benefitsIntro: "How this service benefits your organisation:",
    benefits: [
      "Clear understanding of tax positions",
      "Reduced exposure to disputes and penalties",
      "Tax-efficient structuring within the law",
      "Improved compliance discipline",
      "Business-aligned tax decision-making",
    ],
    research:
      "Our advisory approach balances technical tax expertise with commercial understanding — helping clients navigate complex tax regulations with confidence.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default DirectIndirectTaxAdvisory;
